import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 13a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1l0 -6","key":"svg-0"}],["path",{"d":"M9 9a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1l0 -10","key":"svg-1"}],["path",{"d":"M15 5a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1l0 -14","key":"svg-2"}],["path",{"d":"M4 20h14","key":"svg-3"}]]

const IconChartBarPopular = createReactComponent('outline', 'chart-bar-popular', 'ChartBarPopular', __iconNode);

export default IconChartBarPopular;